export enum HoldbackType {
  FIXED = 'fixed',
  PERCENT = 'percent',
}

export interface IHoldbackFixed {
  type: HoldbackType.FIXED;
  amount: number;
}

export interface IHoldbackPercent {
  cap: number;
  percent: number;
  type: HoldbackType.PERCENT;
}
